module.exports = __webpack_public_path__ + "img/valegor.dea66ef3.png";